import { Box, useToast } from '@chakra-ui/react';
import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
    IUserPreferences,
    selectUserPreferences,
    updateUserPreferencesThunk,
    userPreferencesThunk,
} from '../../app-state/slices/AuthSlice';
import apiClient from '../../canopy-ui-components/api';
import analyticsClient from '../../canopy-ui-components/api/analytics';
import { AppDispatch } from '../../app-state/store';
import { useCurrentColors } from '../../canopy-ui-components/hooks/UseCurrentColors/UseCurrentColors';

export const useUserPreferences = (): [
    { loading: boolean; data?: IUserPreferences | undefined; error: boolean },
    (preferences: IUserPreferences) => Promise<void>
] => {
    const { t } = useTranslation();
    const dispatch = useDispatch<AppDispatch>();
    const userPreferences = useSelector(selectUserPreferences);
    const currentColors = useCurrentColors();
    const toast = useToast();
    // const handleVisibilityChange = useCallback(() => {
    //     if (
    //         document.visibilityState === 'visible' &&
    //         !userPreferences.loading &&
    //         !userPreferences.data
    //     ) {
    //         console.log(!userPreferences.loading && !userPreferences.data);
    //         dispatch(userPreferencesThunk());
    //     }
    // }, [userPreferences.loading]);

    // useEffect(() => {
    //     window.addEventListener('focus', handleVisibilityChange);
    //     return () => {
    //         window.removeEventListener('focus', handleVisibilityChange);
    //     };
    // }, []);

    useEffect(() => {
        if (!userPreferences.loading && !userPreferences.data) {
            dispatch(userPreferencesThunk());
        }
    }, [userPreferences.loading, userPreferences.data]);

    useEffect(() => {
        if (userPreferences.data?.locale) {
            apiClient.updateLocale(userPreferences.data.locale);
            analyticsClient.updateLocale(userPreferences.data.locale);
        }
    }, [userPreferences.data]);

    const showToast = ({ title, backgroundColor }: Record<string, any>) => {
        toast({
            position: 'bottom-right',
            duration: 3000,
            render: () => (
                <Box
                    color="white"
                    p={3}
                    bg={backgroundColor}>
                    {title}
                </Box>
            ),
        });
    };

    const updateUserPreferences = useCallback(
        (preferences: IUserPreferences) => {
            return dispatch(
                updateUserPreferencesThunk({
                    ...userPreferences.data,
                    ...preferences,
                })
            )
                .then(() => {
                    showToast({
                        title: t('notification.preferences-updated-success'),
                        backgroundColor: currentColors.primaryColor,
                    });
                })
                .catch(() => {
                    showToast({
                        title: t('notification.unexpected-error'),
                        backgroundColor: currentColors.errorText,
                    });
                });
        },
        [userPreferences]
    );

    return [userPreferences, updateUserPreferences];
};
